module.exports = __webpack_public_path__ + "img/pic_category_01_w1200.77cdbba1.png";